export default __webpack_public_path__ + "static/media/2.f2ee8388.png";